import { call, put } from "redux-saga/effects";
import type { AxiosResponse } from "axios";
import { ACTIONS, API_URL, STORAGE } from "../_config";
import { CallApi } from "./api/callApi";
import { ActionExtended } from "../_common/interfaces/ActionExtended";

type SagaAction = ActionExtended & {
  callbackSuccess?: (data: unknown) => void;
  callbackError?: (data: unknown) => void;
};

type ApiResponse = AxiosResponse<{
  data?: {
    user?: unknown;
    token?: string;
  };
  token?: string;
}>;

const getErrorData = (error: unknown) => {
  if (error && typeof error === "object" && "data" in error) {
    return (error as { data?: unknown }).data;
  }
  return error;
};

export function* loginUser(action: SagaAction): Generator {
  try {
    const data = action.payload;
    const resp = (yield call(CallApi.POST, API_URL.USER.LOGIN, data)) as ApiResponse;
    if (resp.status >= 200 && resp.status < 300 && resp.data && resp.data.data) {
      // localStorage.setItem(STORAGE, resp.data.data.token);
      // yield put({
      //   type: ACTIONS.USER.LOGIN,
      //   payload: {
      //     user: resp.data.data.user,
      //     token: resp.data.data.token,
      //   }
      // })
      action?.callbackSuccess?.(resp.data);
    } else {
      action?.callbackError?.(resp.data);
    }
  } catch (e) {
    action?.callbackError?.(getErrorData(e));
  }
}

export function* loginUserWithOtp(action: SagaAction): Generator {
  try {
    const data = action.payload;
    const resp = (yield call(CallApi.POST, API_URL.USER.LOGIN_WITH_OTP, data)) as ApiResponse;
    const responseData = resp.data?.data;
    if (resp.status >= 200 && resp.status < 300 && responseData) {
      if (responseData.token) {
        localStorage.setItem(STORAGE, responseData.token);
      }
      yield put({
        type: ACTIONS.USER.LOGIN,
        payload: {
          user: responseData.user,
          token: responseData.token,
        },
      });
      // yield put({
      //   type: ACTIONS.USER.RESET_GUEST_USER_ID,
      // })
      // yield put({
      //   type: ACTIONS.EVENT.RESET_PICK_ID,
      // })
      action?.callbackSuccess?.(resp.data);
    } else {
      action?.callbackError?.(resp.data);
    }
  } catch (e) {
    action?.callbackError?.(getErrorData(e));
  }
}

export function* loginWithEmail(action: SagaAction): Generator {
  try {
    const data = action.payload;
    const resp = (yield call(CallApi.POST, API_URL.USER.LOGIN_WITH_EMAIL, data)) as ApiResponse;
    const responseData = resp.data?.data;
    if (resp.status >= 200 && resp.status < 300 && responseData) {
      if (responseData.token) {
        localStorage.setItem(STORAGE, responseData.token);
      }
      yield put({
        type: ACTIONS.USER.LOGIN,
        payload: {
          user: responseData.user,
          token: responseData.token,
        },
      });
      action?.callbackSuccess?.(resp.data);
    } else {
      action?.callbackError?.(resp.data);
    }
  } catch (e) {
    action?.callbackError?.(getErrorData(e));
  }
}

export function* registration(action: SagaAction): Generator {
  try {
    const data = action.payload;
    const resp = (yield call(CallApi.POST, API_URL.USER.REGISTRATION, data, true)) as ApiResponse;
    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      // console.log('registter', resp)
      if (resp.data.token) {
        localStorage.setItem(STORAGE, resp.data.token);
      }
      yield put({
        type: ACTIONS.USER.LOGIN,
        payload: {
          user: resp.data.data,
          token: resp.data.token,
        },
      });
      action?.callbackSuccess?.(resp.data);
    } else {
      action?.callbackError?.(resp.data);
    }
  } catch (e) {
    action?.callbackError?.(getErrorData(e));
  }
}

export function* forgotPassword(action: SagaAction): Generator {
  try {
    const data = action.payload;
    const resp = (yield call(CallApi.POST, API_URL.USER.FORGOT_PASSWORD, data, true)) as ApiResponse;
    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      action?.callbackSuccess?.(resp.data);
    } else {
      action?.callbackError?.(resp.data);
    }
  } catch (e) {
    action?.callbackError?.(getErrorData(e));
  }
}

export function* resetPassword(action: SagaAction): Generator {
  try {
    const data = action.payload;
    const resp = (yield call(CallApi.POST, API_URL.USER.RESET_PASSWORD, data, true)) as ApiResponse;
    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      action?.callbackSuccess?.(resp.data);
    } else {
      action?.callbackError?.(resp.data);
    }
  } catch (e) {
    action?.callbackError?.(getErrorData(e));
  }
}

export function* logoutUser(action: SagaAction): Generator {
  try {
    const data = action.payload;
    const resp = (yield call(CallApi.POST, API_URL.USER.LOGOUT, data, true)) as ApiResponse;
    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      localStorage.removeItem(STORAGE);
      yield put({
        type: ACTIONS.USER.LOGOUT,
      });
      yield put({
        type: ACTIONS.EVENT.RESET_PICK_ID,
      });
      action?.callbackSuccess?.(resp.data);
    } else {
      action?.callbackError?.(resp.data);
    }
  } catch (e) {
    action?.callbackError?.(getErrorData(e));
  }
}

export function* updateUserProfile(action: SagaAction): Generator {
  try {
    const data = action.payload;
    const resp = (yield call(CallApi.POST, API_URL.USER.UPDATE_PROFILE, data, true)) as ApiResponse;
    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      action?.callbackSuccess?.(resp.data);
    } else {
      action?.callbackError?.(resp.data);
    }
  } catch (e) {
    action?.callbackError?.(getErrorData(e));
  }
}

export function* getUserProfile(action: SagaAction): Generator {
  try {
    const data = action.payload;
    const resp = (yield call(CallApi.GET, API_URL.USER.DETAILS, data, true)) as ApiResponse;
    const responseData = resp.data?.data;
    if (resp.status >= 200 && resp.status < 300 && responseData) {
      yield put({
        type: ACTIONS.USER.ME,
        payload: responseData.user,
      });
      action?.callbackSuccess?.(resp.data);
    } else {
      action?.callbackError?.(resp.data);
    }
  } catch (e) {
    action?.callbackError?.(getErrorData(e));
    yield put({
      type: ACTIONS.USER.LOGOUT,
    });
  }
}

export function* autoLoginWithToken(action: SagaAction): Generator {
  try {
    const data = action.payload;
    const resp = (yield call(CallApi.POST, API_URL.USER.AUTO_LOGIN, data)) as ApiResponse;
    const responseData = resp.data?.data;
    if (resp.status >= 200 && resp.status < 300 && responseData) {
      if (responseData.token) {
        localStorage.setItem(STORAGE, responseData.token);
      }
      yield put({
        type: ACTIONS.USER.LOGIN,
        payload: {
          user: responseData.user,
          token: responseData.token,
        },
      });
      action?.callbackSuccess?.(resp.data);
    } else {
      action?.callbackError?.(resp.data);
    }
  } catch (e) {
    action?.callbackError?.(getErrorData(e));
  }
}

export function* updateDisplayName(action: SagaAction): Generator {
  try {
    const data = action.payload;
    const resp = (yield call(CallApi.POST, API_URL.USER.UPDATE_DISPLAY_NAME, data, true)) as ApiResponse;
    if (resp.status >= 200 && resp.status < 300 && resp.data && resp.data.data) {
      action?.callbackSuccess?.(resp.data);
    } else {
      action?.callbackError?.(resp.data);
    }
  } catch (e) {
    action?.callbackError?.(getErrorData(e));
  }
}

export function* checkValidToken(action: SagaAction): Generator {
  try {
    const data = action.payload;
    const resp = (yield call(CallApi.GET, API_URL.USER.CHECK_VALID_TOKEN, data, true)) as ApiResponse;
    if (resp.status >= 200 && resp.status < 300 && resp.data && resp.data.data) {
      action?.callbackSuccess?.(resp.data);
    } else {
      action?.callbackError?.(resp.data);
    }
  } catch (e) {
    action?.callbackError?.(getErrorData(e));
  }
}

export function* saveNotification(action: SagaAction): Generator {
  try {
    const data = action.payload;
    const resp = (yield call(CallApi.POST, API_URL.USER.SAVE_NOTIFICATION, data, true)) as ApiResponse;
    if (resp.status >= 200 && resp.status < 300 && resp.data && resp.data.data) {
      action?.callbackSuccess?.(resp.data);
    } else {
      action?.callbackError?.(resp.data);
    }
  } catch (e) {
    action?.callbackError?.(getErrorData(e));
  }
}

export function* createUpdateUserGame(action: SagaAction): Generator {
  try {
    const data = action.payload;
    const resp = (yield call(CallApi.POST, API_URL.USER.CREATE_UPDATE_USER_GAME, data, true)) as ApiResponse;
    if (resp.status >= 200 && resp.status < 300 && resp.data && resp.data.data) {
      action?.callbackSuccess?.(resp.data);
    } else {
      action?.callbackError?.(resp.data);
    }
  } catch (e) {
    action?.callbackError?.(getErrorData(e));
  }
}

export function* getRegistrationFieldsData(action: SagaAction): Generator {
  try {
    const data = action.payload;
    const gameId = (data as { gameId?: string | number })?.gameId;
    const resp = (yield call(CallApi.GET, API_URL.USER.REGISTRATION_FIELDS + "/" + gameId, null, true)) as ApiResponse;
    if (resp.status >= 200 && resp.status < 300 && resp.data && resp.data.data) {
      action?.callbackSuccess?.(resp.data);
    } else {
      action?.callbackError?.(resp.data);
    }
  } catch (e) {
    action?.callbackError?.(getErrorData(e));
  }
}
